<template>
  <DialogSetting
    class="cpt-dialog-channel-setting"
    :show="isShowChannelSettings"
    :configs="channel_config"
    :choosed-item.sync="choosedItem"
    :block-heights="blockHeights"
    @bgClick="closeSetting"
    @esc="closeSetting"
  >
    <template #content>
      <component
        :is="curShowComponent.key"
        :key="curShowComponent.key"
        :form="settingForm"
        :show="isShowChannelSettings"
        :channel_data="channel_data"
        :room_data="room_data"
      />
    </template>
  </DialogSetting>
</template>

<script>

import DialogSetting from '@/components/setting/DialogSetting.vue';
const ChannelInfo = () => import('./setting-components/ChannelInfo.vue');
const GroupInfo = () => import('./setting-components/GroupInfo.vue');
const ChannelRoleManage = () => import('@/components/busy/RoleSetting/ChannelRoleManage.vue');
const ChannelInviteManage = () => import('./setting-components/ChannelInviteManage.vue');
import { mapGetters } from "vuex"

import { CHANNEL_CONFIG, GROUP_CONFIG } from './setting-config';
import EventBus from '_lib/EventBus'
import { getRoomInfo } from '_api/room';
import { CHANNEL_SETTING_TYPE_MAP } from '_lib/constants/channel-setting';
import { findChannelSync } from '_js/find-channel';

export default {
  name: 'ChannelSettings',
  components: {
    DialogSetting,
    ChannelInfo,
    GroupInfo,
    ChannelRoleManage,
    ChannelInviteManage
  },
  props: [],
  data() {
    return {
      channel_id: '',
      isShowChannelSettings: false,
      settingForm: {},
      blockHeights: [],
      room_data: {},
      channel_data: {},
      // 当前使用setting的类型
      type: '',
      choosedItem: '',
    }
  },
  computed: {
    channel_config () {
      if(this.type === CHANNEL_SETTING_TYPE_MAP.GROUP){
        return JSON.parse(JSON.stringify(GROUP_CONFIG))
      }
      // 过滤掉没有权限的组件，只要有其中一个权限就进行显示
      let config = JSON.parse(JSON.stringify(CHANNEL_CONFIG))
      for (let i in config) {
        let group = config[i]
        for (let j in group.data) {
          let item = group.data[j], isHidden = true
          if (!item.requirePermissions || item.requirePermissions.length === 0) {
            isHidden = false
          } else {
            for (let permission of item.requirePermissions || []) {
              if (this.$permission.judge(permission, this.channel_id)) {
                isHidden = false
                break
              }
            }
          }
          if (item.hiddenChannelType && item.hiddenChannelType.includes(this.channel_data.channel_type)) {
            isHidden = true
          }
          item.isHidden = isHidden
        }
      }
      return config
    },
    contentComponents() {
      return this.channel_config.map(item => item.data).flat();
    },
    curShowComponent() {
      const defaultConfig = this.channel_config;
      return (
        this.contentComponents.find(
          (item) => item.key === this.choosedItem
        ) || defaultConfig[0].data[0]
      );
    },
    ...mapGetters(['cur_room_data', 'cur_channel_data']),
  },
  mounted () {
    EventBus.$on("SOCKET_UPDATE_ROOM_INFO", this.handleUpdateChannelInfo);
    EventBus.$on("SOCKET_SINGLE_CHANNEL_UPDATE", this.handleSingleChannelUpdate);
    EventBus.$on("Update_Channel_Info", this.updateChannelData);
  },
  beforeDestroy () {
    EventBus.$off("SOCKET_UPDATE_ROOM_INFO", this.handleUpdateChannelInfo);
    EventBus.$off("SOCKET_SINGLE_CHANNEL_UPDATE", this.handleSingleChannelUpdate);
    EventBus.$off("Update_Channel_Info", this.updateChannelData);
  },
  methods: {
    // 在DynamicComponent.vue里面调用init，EventBus.$emit('show-dynamic-component', 'channel-settings')显示
    async init(data) {
      await this.updateChannelSettingHandler(data);
      this.isShowChannelSettings = true;
    },
    async updateChannelSettingHandler({ type, ...data }) {
      this.type = type;
      if(this.type === CHANNEL_SETTING_TYPE_MAP.GROUP){
        this.choosedItem = 'group-info'
        this.channel_id = data.channel_data.channel_id
        const { channel_data } = data;
        const res = await getRoomInfo({room_id: this.$route.params.room_id});
        if (res.data.status == 'ok') {
          const { room_info } = res.data.result;
          this.settingForm = {
            ...this.settingForm,
            ...room_info,
            channel_data: room_info.channels_v2.find(item => item.channel_id == channel_data.channel_id)
          }
        }
        this.channel_data = data.channel_data || {}
        this.room_data = data.room_data || {}
      } else {
        this.choosedItem = 'channel-info'
        this.channel_id = data.channel_data.channel_id
        this.settingForm = data
        this.channel_data = data.channel_data || {}
        this.room_data = data.room || {}
      }
  },
    handleUpdateChannelInfo (d) {
      const channels = d.data.channels || []
      const new_channel = findChannelSync(this.channel_id, channels)
      if (new_channel) {
        this.channel_data = new_channel
      }
    },
    handleSingleChannelUpdate (d) {
      const channel = d.data.channel
      if(channel.channel_id === this.channel_id) {
        this.channel_data = channel
      }
    },
    closeSetting() {
      this.isShowChannelSettings = false;
      this.$emit('close');
    },
    updateChannelData(data) {
      if(data.channel_id == this.channel_data.channel_id) {
        this.channel_data = {
          ...this.channel_data,
          ...data
        }
      }
    }
  },
};
</script>

<style lang="scss">
.cpt-dialog-channel-setting {
  .scroll-item-wrapper {
    &::after {
      display: none;
    }
  }
}
</style>